import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2Incoming: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEmail2Incoming"><Path d="M22 4V8.46191L12 13.501L3.5 9.21777V18.5H12V20H2V4H22Z" fill="currentColor"/><Path d="M19.2803 14.0303L17.0605 16.25H23V17.75H17.0605L19.2803 19.9697L18.2197 21.0303L14.1895 17L18.2197 12.9697L19.2803 14.0303Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2Incoming;
